/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Module
 */
export interface Module {
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof Module
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Module
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    deleted: number;
    /**
     * 
     * @type {object}
     * @memberof Module
     */
    features?: object;
}

export function ModuleFromJSON(json: any): Module {
    return ModuleFromJSONTyped(json, false);
}

export function ModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Module {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'deleted': json['deleted'],
        'features': !exists(json, 'features') ? undefined : json['features'],
    };
}

export function ModuleToJSON(value?: Module | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
        'deleted': value.deleted,
        'features': value.features,
    };
}


